'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Carousel = require('react-bootstrap/lib/Carousel');

var _Carousel2 = _interopRequireDefault(_Carousel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Carousel2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@sketchpixy/rubix/lib/Carousel.js
 ** module id = ./node_modules/@sketchpixy/rubix/lib/Carousel.js
 ** module chunks = 0
 **/